import classNames from 'classnames';
import { AnimatedOpacity } from 'src/animation/AnimatedOpacity';

interface WrapperProps {
  children: React.ReactNode;
  additionalClassName?: string;
  padding?: string;
  classNameAnimation?: string;
}
export const Wrapper = ({
  children,
  additionalClassName,
  padding,
  classNameAnimation
}: WrapperProps) => {
  return (
    <div
      className={classNames(
        'md:min-w-[708px] w-full max-w-[1280px] h-full px-2.5',
        padding ? padding : '',
        additionalClassName
      )}>
      <AnimatedOpacity className={classNameAnimation}>{children}</AnimatedOpacity>
    </div>
  );
};
